import React, { Component } from "react";
import { getApplyPage } from "../contentful";
import marked from "marked";
import TitleBar from "./TitleBar";
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { Helmet } from "react-helmet";

Modal.setAppElement('#root');

class Apply extends Component {
  state = {
    text: "",
    modalIsOpen: false
  };

  getMarkdownText() {
    var rawMarkup = marked(this.state.text, { sanitize: true });
    return { __html: rawMarkup };
  }

  componentDidMount() {
    getApplyPage().then((data) =>
      this.setState({ text: data[0].fields.content })
    );
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Lucille Graham Trust || Apply for Grant</title>
          <meta
            name="description"
            content="The Lucille Graham Trust Trustees meet twice a year to consider applications for grants."
          />
          <link
            rel="canonical"
            href="https://www.lucillegrahamtrust.org.uk/apply"
          />
        </Helmet>
        <TitleBar title="Apply" />
        <div className="content">
          <div dangerouslySetInnerHTML={this.getMarkdownText()} />

        </div>




      </>
    );
  }
}

export default Apply;
